import { render, staticRenderFns } from "./MerchantInvoices.vue?vue&type=template&id=420962ea"
import script from "./MerchantInvoices.vue?vue&type=script&lang=js"
export * from "./MerchantInvoices.vue?vue&type=script&lang=js"
import style0 from "./MerchantInvoices.vue?vue&type=style&index=0&id=420962ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports